import { render, staticRenderFns } from "./journal-settings.vue?vue&type=template&id=73869d48"
import script from "./journal-settings.vue?vue&type=script&lang=js"
export * from "./journal-settings.vue?vue&type=script&lang=js"
import style0 from "./journal-settings.vue?vue&type=style&index=0&id=73869d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports